module.exports = __webpack_public_path__ + "assets/img/contact-h.0b4b04e8.png";